export default {
  mdmIOSUserEnrollment: `Enrolling a personal iOS mobile device in MDM lets the user 
  access company information on a separate partition on the device. After the device
  is enrolled in MDM, view and manage the device in DEVICE MANAGEMENT > Devices in
  the Admin Portal.`,
  mdmIOSAdminEnrollment: `Enrolling a company-owned iOS mobile device in MDM is a secure way to 
  manage the device and its data. After the device is enrolled in MDM, 
  view and manage the device in DEVICE MANAGEMENT > Devices.`,
};
